import {
    aksCatalogDefinitionId,
    AlbCatalogDefinitionId,
    couchbaseDbDefinitionId,
    eipStackCatalogDefinitionId,
    eventhubDefinitionId,
    kafkaCatalogDefinitionId,
    keyvaultCatalogDefinitionId,
    linuxCatalogDefinitionId,
    linuxOELCatalogDefinitionId,
    linuxSLESCatalogDefinitionId,
    oelOracleCatalogDefinitionId,
    oracleIaaSDefinitionId,
    pECatalogDefinitionId,
    NsgAutomationRulesProvisioningCatalogDefinitionID,
    sqlIaaSCatalogDefinitionId,
    sqlPaaSCatalogDefinitionId,
    storageCatalogDefinitionId,
    windowsCatalogDefinitionId,
    RICatalogDefinitionId,
    Day2CatalogDefinitionId,
    SecurityToolCatalogDefinitionId,
    SsoOktaCatalogDefinitionId,
    SsoOktaModifyCatalogDefinitionId,
    ServiceAccountDefinitionId,
    ApplicationGateWayURLCatalogDefinitionID,
    InternalApplicationGateWayURLCatalogDefinitionID,
    ExternalPublicLoadBalancerURLCatalogDefinitionID,
    ProjectOnboardCatalogDefinitionId,
    VirtualServiceCatalogDefinitionId,
    SlesPgtCatalogDefinitionId,
    NewInternalApplicationGateWayProvisioningCatalogDefinitionID,
    SlesPgtDBCatalogDefinitionId,
    CloudOnboardingCatalogDefinitionID,
    pgcsSqlIaaSCatalogDefinitionId,
    edapAksCatalogDefinitionId,
    pgcsWindowsVmCatalogDefinitionId,
    AwsEC2CatalogDefinitionId,
    AwsRHELCatalogDefinitionId,
    AwsSLESCatalogDefinitionId,
    AwsOELCatalogDefinitionId,
    AwsOracleRDSCatalogDefinitionId,
    AwsS3BucketCatalogDefinitionId,
    AwsSQLRDSCatalogDefinitionId,
    AwsPostgresqlCatalogDefinitionId,
    AwsDynamoDbCatalogDefinitionId,
    AwsEksnCatalogDefinitionId,
    AwsSQLIaasCatalogDefinitionId,
    AwsOracle19CCatalogDefinitionId,
    AwsCloudOnboardingCatalogDefinitionId,
    AwsAccountVendingCatalogDefinitionId,
    GithubOnboardingCatalogDefinitionId,
} from 'utils/catalogDefinitionId';
import { DateTime } from 'luxon';

export const orderTypeOptions = [
    { label: 'All Orders', value: 'All Orders' },
    { label: 'My Orders', value: 'My Orders' },
];
export const filterDefaultObj = () => ({
    orderType: 'All Orders',
    sectors: [],
    status: [],
    orderId: '',
    requestorId: null,
    applicationName: null,
    cloudProvider: null,
    catalogServiceCodes: [],
    fromDate: null,
    toDate: null,
});

export const orderPageInterval = {
    orderDetail: 10000,
    catalogLogs: 10000,
    itemLogs: 10000,
    preLogs: 10000,
};

export const generateOrderPageFilterObj = ({ appliedFilters, additionalPayload }) => {
    const payload = {
        ...appliedFilters,
        toDate: appliedFilters?.toDate ? DateTime.fromJSDate(appliedFilters?.toDate).endOf('day').toUTC().toFormat("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'") : null,
        fromDate: appliedFilters?.fromDate
            ? DateTime.fromJSDate(appliedFilters?.fromDate).startOf('day').toUTC().toFormat("yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
            : null,
    };
    return {
        ...payload,
        ...additionalPayload,
    };
};

export const getRedirectionpath = ({ catalogServiceCode, cartItemId, catalogServiceId, isSQLServer }) => {
    let path = '';
    const editPath = `${catalogServiceCode}/edit/${cartItemId}/${catalogServiceId}`;
    if (windowsCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/vm-provisioning/Windows/WindowsServer/${catalogServiceCode}/edit/${cartItemId}/${catalogServiceId}`;
    }
    if (
        linuxCatalogDefinitionId.includes(catalogServiceCode) &&
        !linuxOELCatalogDefinitionId.includes(catalogServiceCode) &&
        !linuxSLESCatalogDefinitionId.includes(catalogServiceCode)
    ) {
        path = `/vm-provisioning/Linux/RHEL/${editPath}`;
    }
    if (linuxOELCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/vm-provisioning/Linux/OEL/${editPath}`;
    }
    if ([...linuxSLESCatalogDefinitionId, ...SlesPgtCatalogDefinitionId, ...SlesPgtDBCatalogDefinitionId].includes(catalogServiceCode)) {
        path = `/vm-provisioning/Linux/SLES/${editPath}`;
    }
    if (sqlPaaSCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/sql-paas-provisioning/${editPath}`;
    }
    if (oracleIaaSDefinitionId.includes(catalogServiceCode) && !oelOracleCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/oracle-provisioning/Linux/RHEL/${editPath}`;
    }
    if (oelOracleCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/oracle-provisioning/Linux/OEL/${editPath}`;
    }
    if (sqlIaaSCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/iaas-sql-provisioning/Windows/WindowsServer/${editPath}`;
    }
    if (pgcsSqlIaaSCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/pgcs-iaas-sql-provisioning/Windows/WindowsServer/${editPath}`;
    }
    if (pgcsWindowsVmCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/pgcs-vm-provisioning/Windows/WindowsServer/${editPath}`;
    }
    if (storageCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/azure-storage-provisioning/${editPath}`;
    }
    if (aksCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/aks-nms-provisioning/${editPath}`;
    }
    if (edapAksCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/edap-aks-nms-provisioning/${editPath}`;
    }
    if (AlbCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/azure-load-balancer/${editPath}`;
    }
    if (keyvaultCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/azure-key-vault/${editPath}`;
    }
    if (kafkaCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/kafka-topic-provisioning/${editPath}`;
    }
    if (eventhubDefinitionId.includes(catalogServiceCode)) {
        path = `/event-hub-provisioning/${editPath}`;
    }
    if (pECatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/private-endpoint-provisioning/${editPath}`;
    }
    if (eipStackCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/app-microservices-stack/${editPath}`;
    }
    if (couchbaseDbDefinitionId.includes(catalogServiceCode)) {
        path = `/couchbase-provisioning/${editPath}`;
    }
    if (RICatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/reference-implementation-provisioning/${editPath}`;
    }
    if (Day2CatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/access-management-myidm/${editPath}`;
    }
    if (SecurityToolCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/security-tool/${editPath}`;
    }
    if (SsoOktaCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/sso-okta-onboarding/${editPath}`;
    }
    if (SsoOktaModifyCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/sso-okta-modification/${editPath}`;
    }
    if (ServiceAccountDefinitionId.includes(catalogServiceCode)) {
        if (isSQLServer) {
            path = `/service-account-ci/${editPath}`;
        } else {
            path = `/service-account-creation/${editPath}`;
        }
    }
    if (ApplicationGateWayURLCatalogDefinitionID?.includes(catalogServiceCode)) {
        path = `/azure-application-gateway-url-onboarding/${editPath}`;
    }
    if (InternalApplicationGateWayURLCatalogDefinitionID?.includes(catalogServiceCode)) {
        path = `/azure-internal-application-gateway-url-onboarding/${editPath}`;
    }
    if (ExternalPublicLoadBalancerURLCatalogDefinitionID?.includes(catalogServiceCode)) {
        path = `/azure-external-public-load-balancer-url-onboarding/${editPath}`;
    }
    if (ProjectOnboardCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/project-onboarding/${editPath}`;
    }
    if (VirtualServiceCatalogDefinitionId.includes(catalogServiceCode)) {
        path = `/aks-vs-provisioning/${editPath}`;
    }
    if (NewInternalApplicationGateWayProvisioningCatalogDefinitionID.includes(catalogServiceCode)) {
        path = `/azure-new-internal-application-gateway-provisioning/${editPath}`;
    }
    if (NsgAutomationRulesProvisioningCatalogDefinitionID.includes(catalogServiceCode)) {
        path = `/application-nsgrules-automation/${editPath}`;
    }
    if (CloudOnboardingCatalogDefinitionID?.includes(catalogServiceCode)) {
        path = `/cloud-adoption/${editPath}`;
    }
    if (AwsEC2CatalogDefinitionId?.includes(catalogServiceCode)) {
        path = `/aws-vm-provisioning/Windows/WindowsServer/${editPath}`;
    }
    if (AwsRHELCatalogDefinitionId?.includes(catalogServiceCode)) {
        path = `/aws-vm-provisioning/Linux-Rhel/${editPath}`;
    }
    if (AwsSLESCatalogDefinitionId?.includes(catalogServiceCode)) {
        path = `/aws-vm-provisioning/Linux/SLES/${editPath}`;
    }
    if (AwsOELCatalogDefinitionId?.includes(catalogServiceCode)) {
        path = `/aws-vm-provisioning/Linux-OEL/${editPath}`;
    }
    if (AwsOracleRDSCatalogDefinitionId?.includes(catalogServiceCode)) {
        path = `/aws-provisioning/oracle-rds/${editPath}`;
    }
    if (AwsS3BucketCatalogDefinitionId?.includes(catalogServiceCode)) {
        path = `/aws-s3-provisioning/${editPath}`;
    }
    if (AwsSQLRDSCatalogDefinitionId?.includes(catalogServiceCode)) {
        path = `/aws-provisioning/sql-rds/${editPath}`;
    }
    if (AwsPostgresqlCatalogDefinitionId?.includes(catalogServiceCode)) {
        path = `/aws-provisioning/postgresql-rds/${editPath}`;
    }
    if (AwsDynamoDbCatalogDefinitionId?.includes(catalogServiceCode)) {
        path = `/aws-provisioning/dynamodb-rds/${editPath}`;
    }
    if (AwsEksnCatalogDefinitionId?.includes(catalogServiceCode)) {
        path = `/aws-eks-nms-provisioning/${editPath}`;
    }
    if (AwsSQLIaasCatalogDefinitionId?.includes(catalogServiceCode)) {
        path = `/aws-iaas-sql-provisioning/Windows/WindowsServer/${editPath}`;
    }
    if (AwsOracle19CCatalogDefinitionId?.includes(catalogServiceCode)) {
        path = `/aws-oracle-provisioning/Linux/OEL/${editPath}`;
    }
    if (AwsCloudOnboardingCatalogDefinitionId?.includes(catalogServiceCode)) {
        path = `/awscloud-adoption/${editPath}`;
    }
    if (AwsAccountVendingCatalogDefinitionId?.includes(catalogServiceCode)) {
        path = `/awsaccount-onboard/${editPath}`;
    }
    if (GithubOnboardingCatalogDefinitionId?.includes(catalogServiceCode)) {
        path = `/github-onboarding/${editPath}`;
    }

    return path;
};

export const ignoreManualFetchStatus = ['cancelled', 'rejected', 'completed'];

// Group approvers by approverType
const groupedApprovers = (approvers) => {
    return approvers.reduce((groups, approver) => {
        const type = approver.approverType || 'Unknown';
        const updatedGroups = { ...groups };
        if (!updatedGroups[type]) {
            updatedGroups[type] = [];
        }
        updatedGroups[type].push(approver);
        return updatedGroups;
    }, {});
};

export const matchApproversToGroupNamesFromData = (data) => {
    const approvers = data?.approvers || [];
    const catalogServices = data?.catalogServices || [];

    return approvers.map((approver) => {
        const approverId = approver?.approver?.id || approver?.approver?.gpid;
        const groupNames = catalogServices
            .filter((service) => service?.catalogConfig?.groupOwner?.gpid === approverId && service?.catalogConfig?.groupName)
            .map((service) => service.catalogConfig.groupName);

        return {
            ...approver,
            groupNames,
        };
    });
};

export const getGroupedApproversByTypeGithub = (data) => {
    const approvers = data?.approvers || [];
    return approvers.reduce((groups, approver) => {
        const type = approver.approverType || 'Unknown';

        const updatedGroups = { ...groups };
        if (!updatedGroups[type]) {
            updatedGroups[type] = [];
        }
        updatedGroups[type].push(approver);
        return updatedGroups;
    }, {});
};

export const getGroupedApproversByType = (data) => {
    const approvers = matchApproversToGroupNamesFromData(data);
    return groupedApprovers(approvers);
};

/**
 * Checks if approvers of a specific type have null or pending approval status
 * @param {Object} approvers - Object containing approvers grouped by type
 * @param {string} key - The approver type to check (e.g., "Application Owner")
 * @param {string|Array} pendingStatus - String or array of strings representing pending status values
 * @returns {boolean} - True if any approver has null/undefined or pending status
 */
export const isPendingOrNullApprovalStatus = (approvers, key, pendingStatus = 'Pending Approval') => {
    // Check if approvers object exists and has the specified key
    if (!approvers || !approvers[key] || !Array.isArray(approvers[key]) || approvers[key].length === 0) {
        return true; // Consider missing approvers as pending
    }

    // Convert pendingStatus to array if it's a string
    const pendingStatusArray = Array.isArray(pendingStatus) ? pendingStatus : [pendingStatus];

    // Check if any approver has null/undefined status or a pending status
    return approvers[key].some((approver) => !approver.status || pendingStatusArray.includes(approver.status));
};

/**
 * Returns approver types where at least one approver has "Rejected" status
 * @param {Object} approvers - Object containing approvers grouped by type
 * @returns {Array} - Array of approver types where at least one approver has "Rejected" status
 */
export const getRejectedApproverTypes = (approvers) => {
    if (!approvers) return [];

    return Object.keys(approvers).filter((key) => {
        if (!approvers[key] || !Array.isArray(approvers[key]) || approvers[key].length === 0) {
            return false;
        }

        return approvers[key].some((approver) => approver.status === 'Rejected');
    });
};

/**
 * Transforms approver type labels based on catalog service code
 * Updates approver labels for GitHub onboarding catalog codes
 * @param {Object} groupedApprovers - Object containing approvers grouped by type
 * @param {string} catalogServiceCode - The catalog service code to check
 * @returns {Object} - Transformed approvers object with updated labels
 */
export const transformApproverLabelsForCatalog = (groupedApproversByType, catalogServiceCode) => {
    if (!groupedApproversByType || !catalogServiceCode) return groupedApproversByType;

    // Check if this is a GitHub onboarding catalog
    const isGithubCatalog = GithubOnboardingCatalogDefinitionId.includes(catalogServiceCode);

    if (!isGithubCatalog) return groupedApproversByType;

    const transformed = { ...groupedApproversByType };

    const renameKey = (sourceApproverType, displayApproverType) => {
        if (!transformed[sourceApproverType]) return;
        if (!transformed[displayApproverType]) {
            transformed[displayApproverType] = transformed[sourceApproverType];
        } else {
            transformed[displayApproverType] = [...transformed[displayApproverType], ...transformed[sourceApproverType]];
        }
        delete transformed[sourceApproverType];
    };

    // - Application Owner -> Business Application Owner
    // - Active Directory Group Owner -> Requestor Manager
    // - ADO Owner -> GitHub AD Group Owner
    renameKey('Application Owner', 'Business Application Owner');
    renameKey('Active Directory Group Owner', 'Requestor Manager');
    renameKey('ADO Owner', 'GitHub AD Group Owner');

    return transformed;
};

/**
 * Wrapper function that gets grouped approvers and transforms labels based on catalog code
 * @param {Object} data - Order data containing approvers and catalog services
 * @returns {Object} - Grouped approvers with transformed labels
 */
export const getGroupedApproversWithTransformedLabels = (data) => {
    const groupedApproversByType = getGroupedApproversByType(data);
    const catalogServiceCode = data?.catalogServices?.[0]?.catalogServiceCode;
    return transformApproverLabelsForCatalog(groupedApproversByType, catalogServiceCode);
};
